/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import FilterListIcon from "@mui/icons-material/FilterList";
import { MdOutlineErrorOutline } from "react-icons/md";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import DropOutModal from "../../../components/ModalComponents/DropOutModal";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useAppDispatch, useAppSelector } from "../../../useStore";
import { getallapplicant, reset } from "../../../features/Applicant/applicantSlice";
import { EntriesPerPage, Search, TableFetch } from "../../../components/TableOptions";
import Pagination from "../../../components/Pagination";
import swal from "sweetalert";
import InterviewModals from "../../../components/ModalComponents/InterviewModals";
import EvaluationUpdateModal from "../../../components/ModalComponents/EvaluationUpdateModal";
import moment from "moment";
import toast, { Toaster } from "react-hot-toast";
import XLoader from "../../../components/XLoader";
import InterviewModal from "../../../components/ModalComponents/InterviewModal";
import { FaFilePdf, FaFileCsv, FaFileImage, FaFile } from "react-icons/fa";
import PdfViewer from "../../../components/PdfViewer";
import ImageLightbox from "../../../components/ImageLightbox";
import EditApplicant from "../../../components/ModalComponents/EditApplicant";
import ReplaceID from "../../../components/ModalComponents/ReplaceID";
import InterviewDrawerComponent from "../ApplicantDrawerComponent/InterviewDrawerComponent";




const EvaluatingTable = ({
  pageHeader,
  headerTitles,
  setResetID
}: any) => {
  const dispatch = useAppDispatch();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedIds, setSelectedIds] = useState<string[]>([]); // State to hold selected IDs
  const [selectedItems, setSelectedItems] = useState<any[]>([]); // State to hold selected items
  const handleCheckboxChange = (itemId: string, item: any) => {
  setIsDrawerOpen(true);
  // Check if the item's ID is already selected
  if (selectedIds.includes(itemId)) {
  // Remove the ID from the selectedIds array
  setSelectedIds(selectedIds.filter((id) => id !== itemId));
  setSelectedItems((prevSelectedItems) => prevSelectedItems.filter((i) => i.id !== itemId));
  } else {
  // Add the ID to the selectedIds array
  setSelectedIds([...selectedIds, itemId]);
  setSelectedItems((prevSelectedItems) => [...prevSelectedItems, item]);
  }
 };

  const {
    EvalvationisSuccess,
    UpdateScreeningStatusisSuccess,
    sendOfferisSuccess,
    applicationInterviewisSuccess,
    updateApplicationInterviewStatusisSuccess,
    sendEmailisSuccess,
    shareApplicationisSuccess,
    ScreeningisSuccess,
    applicationassignedisSuccess,
    scheduleApplicantisSuccess,
    updateInterviewStatusisSuccess,
    UpdateEvaluatingStatusisSuccess,
    UpdateOfferisSuccess,
    sendForHireisSuccess,
    EditapplicantionisSuccess,
    sendForTranningisSuccess,
    updateTranningisSuccess,
    data,
    isError,
    isLoading,
    message,
  } = useAppSelector((state: { applicant: any }) => state.applicant);

  useEffect(() => {
    if (
      EvalvationisSuccess ||
      UpdateScreeningStatusisSuccess ||
      sendOfferisSuccess ||
      applicationInterviewisSuccess ||
      updateApplicationInterviewStatusisSuccess ||
      sendEmailisSuccess ||
      shareApplicationisSuccess ||
      ScreeningisSuccess ||
      applicationassignedisSuccess ||
      scheduleApplicantisSuccess ||
      updateInterviewStatusisSuccess ||
      UpdateEvaluatingStatusisSuccess ||
      UpdateOfferisSuccess ||
      sendForHireisSuccess ||
      EditapplicantionisSuccess ||
      sendForTranningisSuccess ||
      updateTranningisSuccess
    ) {
      const input = { applicationStatus: "EVALUATION" };
      // @ts-ignore 
      dispatch(getallapplicant(input))

      setTimeout(() => {
        dispatch(reset());
      }, 2000);
    }
  }, [
    UpdateOfferisSuccess,
    EvalvationisSuccess,
    UpdateScreeningStatusisSuccess,
    sendOfferisSuccess,
    applicationInterviewisSuccess,
    updateApplicationInterviewStatusisSuccess,
    sendEmailisSuccess,
    shareApplicationisSuccess,
    ScreeningisSuccess,
    applicationassignedisSuccess,
    scheduleApplicantisSuccess,
    updateInterviewStatusisSuccess,
    UpdateEvaluatingStatusisSuccess,
    sendForHireisSuccess,
    EditapplicantionisSuccess,
    sendForTranningisSuccess,
    updateTranningisSuccess,
    dispatch,
  ]);



  const [show, setShow] = useState(false);
  const [isPDF, setIsPDF] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const openModal = (fileUrl, fileType, file) => {
    setSelectedFile(file);
    setIsPDF(fileType === 'pdf');
    setShow(true);
  };


  const getFileIcon = (fileType: any) => {
    switch (fileType) {
      case 'pdf':
        return <FaFilePdf color={"red"} size={25} />;
      case 'csv':
        return <FaFileCsv size={25} color={"green"} />;
      case 'jpeg':
      case 'jpg':
      case 'png':
        return <FaFileImage size={25} color={"gray"} />;
      default:
        return <FaFile size={25} />;
    }
  };


  useEffect(() => {
    const input = { applicationStatus: "EVALUATION" };
    // @ts-ignore 
    dispatch(getallapplicant(input))
  }, [dispatch])
  
  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
   };

  useEffect(() => {
    if (isError) {
      swal({
        title: "error",
        text: message,
        icon: "error"
      })
      dispatch(reset())
    }
  }, [dispatch, isError, message])




  const [datas, setDatas] = useState([]);
  const [searchItem, setSearchItem] = useState("");
  const [entriesperpage, setEntriesPerPage] = useState(() => {
    return "8";
  });

  // console.log('datas', datas);
  useEffect(() => {
    const result = data?.data?.filter((item: any) =>
      item?.firstName?.toLowerCase()?.includes(searchItem) ||
      item?.middleName?.toLowerCase()?.includes(searchItem) ||
      item?.LastName?.toLowerCase()?.includes(searchItem)
    );
    setDatas(result);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, searchItem]);

  const [displayData, setDisplayData] = useState([]);

  const handleShow = () => {
    toast.error("Evaluation have not been Completed")
  }



  return (
    <div>

      <Toaster
        position="top-center"
        toastOptions={{
          duration: 5000,
          error: {
            duration: 20000,
          },
        }}
      />

      <section className="md-ui component-data-table">
        <header className="main-table-header">
          <div className="main-table-search-container">
            <h1 className="table-header--title">{pageHeader}</h1>
            <Search
              searchItem={searchItem}
              setSearchItem={setSearchItem}
              placeholder={pageHeader}
            />
            <div>
              <EntriesPerPage
                data={datas}
                entriesperpage={entriesperpage}
                setEntriesPerPage={setEntriesPerPage}
              />
            </div>
            <span className="table-header--icons">
              <FilterListIcon />
            </span>
          </div>
        </header>
        {isLoading && <XLoader isLoading={isLoading} />}
        <div className="main-table-wrapper">
          <table className="main-table-content">
            <thead className="data-table-header">
              <tr className="data-table-row">
                {headerTitles.map((title: any, i: any) => (
                  <td className="table-datacell datatype-string headerTitles" key={i} >
                    {title}
                  </td>
                ))}
              </tr>
            </thead>
            <tbody className="data-table-content">
              {isLoading ? (
                <TableFetch colSpan={12} />
              ) : displayData?.length === 0 ||
                displayData?.length === undefined ? (
                <tr>
                  <td className="table-msg" colSpan={12}>
                    <MdOutlineErrorOutline size={75} />
                    <p>No Record found!</p>
                  </td>
                </tr>
              ) : (
                displayData?.map((item: any, i: any) => (
                  <tr className="data-table-row" key={i}>
                       <td>
                       {item?.EvaluatingLog?.evaluatingStatus === "PENDING" ? ( 
    (  <div className="md-checkbox">
      <input
        id={i}
        type="checkbox"
        onClick={handleShow} 
      />
      <label htmlFor={i}></label>
    </div>)
  ) : (
    <div className="md-checkbox">
    <input
      id={i}
      type="checkbox"
      checked={selectedIds?.includes(item?.id)}
      onChange={() => handleCheckboxChange(item?.id, item)}
    />
    <label htmlFor={i}></label>
  </div>
  )}
                      </td>
                    <td className="table-datacell datatype-string">
                      <div className="dropdown">
                        <button className="dropbtn">
                          <MoreHorizIcon />
                        </button>
                        <div className="dropdown-content">
                          <a>
                            {item?.EvaluatingLog?.evaluatingStatus === "PENDING" ?
                              <div onClick={handleShow}>Send for Interview</div> :
                              <InterviewModal
                                title="Send for Interview"
                                nametitle={item?.title}
                                name={[item]}
                                id={item?.id}
                              />

                            }
                          </a>
                          <a>
                            <DropOutModal
                              title="Dropout"
                              id={item?.id}
                              name={`${!item?.firstName ? "" : item?.firstName} ${!item?.middleName ? "" : item.middleName} ${!item?.LastName ? "" : item?.LastName}`.trim()}
                            />
                          </a>

                        </div>
                      </div>
                    </td>
                    <td className="table-datacell datatype-string">
                      <div className="dropdown">

                        <EvaluationUpdateModal
                          disabled={item?.EvaluatingLog?.evaluatingStatus === "PENDING" ? false : true}
                          title={"Send for Screening"}
                          nametitle={item.title}
                          name={`${item?.firstName || ''} ${item?.middleName || ''} ${item?.LastName || ''}`}
                          id={item?.EvaluatingLog?.id}
                        />
                      </div>
                    </td>

                    <td className="table-datacell datatype-numeric toggle">
                      {!item.firstName ? "" : item.firstName} {!item.middleName ? "" : item.middleName} {!item.LastName ? "" : item.LastName}
                      {pageHeader.includes("History")}
                    </td>
                    <td className="table-datacell datatype-string">
                      {item?.gender}
                    </td>
                    <td className="table-datacell datatype-string">
                      {moment(!item?.dateOfBirth ? "n/a" : item?.dateOfBirth).format("DD-MM-YYYY")}
                    </td>
                    <td className="table-datacell datatype-string">
                      <Link
                        to={`/viewapplicants/${item?.id}`}
                        className="applicant-btn"
                      >
                        <Button className="view-job-profile">View</Button>
                      </Link>
                    </td>

                    <td className="table-datacell datatype-string">
                      {item?.verificationID
                        ? (

                          <div className="table-datacell-flex">
                          <span
                            style={{ marginRight: '5px', cursor: 'pointer' }}
                            onClick={() => {
                              const fileExtension = item?.verificationID.split('.').pop().toLowerCase();
                              openModal(item?.verificationID, fileExtension, item?.verificationID,);
                            }}>
                            {getFileIcon(item?.verificationID.split('.').pop().toLowerCase())}
                          </span>
                          <ReplaceID id={item?.id} setResetID={setResetID} />
                          </div>
                        )
                        : <div className="table-datacell-flex">
                         <span>
                          No ID
                         </span>
                        <ReplaceID id={item?.id} setResetID={setResetID} />
                       </div>
                      }
                    </td>
                    <td className="table-datacell datatype-string">
                      {moment(item?.createdAt).format("DD-MM-YYYY")}
                    </td>
                    <td className="table-datacell datatype-string">
                      {moment(item?.updatedAt).format("DD-MM-YYYY")}
                    </td>
                    <td className="table-datacell datatype-numeric">
                      <InterviewModals
                        email={item.email}
                        nametitle={item.title}
                        name={
                          item.firstName +
                          " " +
                          item.middleName +
                          " " +
                          item.LastName
                        }
                        id={item.id}
                      />
                    </td>
                    <td className="table-datacell datatype-numeric">
                      {item?.applicationStatus}
                    </td>
                    <td className="table-datacell datatype-numeric">
                      {item.email}
                    </td>
                    <td className="table-datacell datatype-string">
                      {item?.phoneNumber}
                    </td>
                    <td className="table-datacell datatype-string">
                      {!item?.location ? "n/a" : item?.location}
                    </td>
                    <td className="table-datacell datatype-string">
                      <EditApplicant name={item} id={item?.id} />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
            {isPDF ? (
              <PdfViewer fileUrl={selectedFile} setShow={setShow} show={show} />
            ) : (
              <ImageLightbox images={selectedFile} setShow={setShow} show={show} />
            )}
          </table>
        </div>
        <div className="table-footer">
          <div>
            <Pagination
              setDisplayData={setDisplayData}
              data={datas}
              entriesperpage={entriesperpage}
              Total={"Evaluating"}
            />
          </div>
          <InterviewDrawerComponent 
               isOpen={isDrawerOpen} onClose={toggleDrawer} data={selectedItems} id={selectedIds} />
        </div>
      </section>
    </div>
  );
};

export default EvaluatingTable;
